export default function CTA() {
  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="bg-gradient-to-br from-[#8B1538] to-[#6a1029] rounded-3xl p-12 md:p-16 text-white text-center shadow-2xl">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Montserrat']">
            Need Transportation Solutions?
          </h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto leading-relaxed">
            Whether you need raw material transport, finished product delivery, or truck hiring services, TMI Logistics has the expertise and fleet to meet your needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="/contact"
              className="px-10 py-4 bg-white text-[#8B1538] rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Request a Quote
            </a>
            <a
              href="tel:+27123456789"
              className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-lg hover:bg-white hover:text-[#8B1538] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Call: +27 12 345 6789
            </a>
          </div>
          <div className="mt-12 pt-8 border-t border-white/30">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold mb-2">Own Fleet + Partners</div>
                <div className="text-sm uppercase tracking-wide opacity-90">Transportation Network</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">70-120km Radius</div>
                <div className="text-sm uppercase tracking-wide opacity-90">Service Coverage</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">JIT Delivery</div>
                <div className="text-sm uppercase tracking-wide opacity-90">Reliable Scheduling</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}